import instanceJWT from "./apiJwt";

/**
 * Строки журнала заказов по их ключам (`eplex/orders/journal?hash_key_in=…`).
 *
 * Ручка отдаёт ровно запрошенные строки, без ограничения по датам и типу —
 * так следим за судьбой конкретных позиций (оформилась у поставщика или нет),
 * не перечитывая весь журнал (CAB-782). Проверено на стенде 30.09.2026:
 * `hash_key_in` — точное перечисление, `thash_in` ручка не понимает и молча
 * отдаёт всю выборку.
 */
export type JournalRow = Record<string, unknown>;

export async function fetchJournalRowsByHash(hashKeys: readonly string[]): Promise<JournalRow[]> {
  if (hashKeys.length === 0) return [];

  const params = new URLSearchParams({ hash_key_in: hashKeys.join(","), limit: "max", offset: "0" });
  const response = await instanceJWT.get<{ data?: { data?: JournalRow[] } }>(
    `eplex/orders/journal?${params.toString()}`,
  );

  return response.data?.data?.data ?? [];
}
